import React from "react";

import AboutCarte from "../../components/AboutCarte";
import Landing from "../../components/AboutPage/Landing";
import History from "../../components/AboutPage/History";
import Mission from "../../components/AboutPage/Mission";
import Partners from "../../components/AboutPage/Partners";
import Solutions from "../../components/AboutPage/Solutions";
import Contact from "../../components/AboutPage/Contact";

const CardTab = [
  {
    image: "./assets/images/AboutUs/icons8-dev-100.png",
    altImage: "baliseCode",
    titre: "Innovation et Technologie",
    description:
      "Ekose fournit des informations instantanées sur la disponibilité des soins et des médicaments, offrant aux patients et aux prestataires une visibilité continue pour une meilleure prise en charge.",
  },
  {
    image: "./assets/images/AboutUs/icons8-stéthoscope-48.png",
    altImage: "Stétoscope",
    titre: "Modèle de santé en équipe et Télémedecine",
    description:
      "Grâce à un modèle de soins collaboratif, Ekose facilite la téléconsultation, permettant aux patients d'accéder aux soins de santé à distance et aux soignants de travailler ensemble de manière coordonnée.",
  },
  {
    image: "./assets/images/AboutUs/data-svgrepo-com (1).png",
    altImage: "data",
    titre: "Innovation et technologie",
    description:
      "Ekose fournit des informations instantanées sur la disponibilité des soins et des médicaments, offrant aux patients et aux prestataires une visibilité continue pour une meilleure prise en charge.",
  },
  {
    image: "./assets/images/AboutUs/heart-pulse-2-svgrepo-com.png",
    altImage: "heart",
    titre: "Innovation et technologie",
    description:
      "Ekose incite les patients à s’engager activement dans leur parcours de santé, récompensant les efforts pour améliorer la continuité et l’efficacité des soins.",
  },
  {
    image: "./assets/images/AboutUs/documents-svgrepo-com.png",
    altImage: "documents",
    titre: "Innovation et technologie",
    description:
      "Ekose fournit des informations instantanées sur la disponibilité des soins et des médicaments, offrant aux patients et aux prestataires une visibilité continue pour une meilleure prise en charge.",
  },
  {
    image: "./assets/images/AboutUs/secure-svgrepo-com.png",
    altImage: "secure",
    titre: "Innovation et technologie",
    description:
      "Vos informations personnelles et médicales restent protégées.",
  },
];
const About = () => {
  return (
    <main>
      <Landing />
      <History />
      <Mission />
      <Partners />
      <Solutions />
    <Contact />

      {/* section trois */}
      {/* <section className=" h-[80vh] min-h-[80vh]  bg-[#134888] flex justify-center items-center m-auto lt:max-sm:flex-col lt:max-sm:text-center ">
        <div className="  w-[40%] min-w-[40%] lt:max-sm:w-[80%] ">
          <p className="text-[#32E800] font-bold mb-4 text-[2rem] w-[500px] lt:text-[1em] sm:text-[1.5rem] ">
            Des partenaires de qualité nous soutiennent
          </p>
          <p className="text-left text-base text-white w-[350px] lt:max-sm:w-full ">
            Ekose-RX est soutenu par des partenaires de qualité, engagés à
            améliorer l'accès et la qualité des soins grâce à des solutions de
            santé innovantes et accessibles.
          </p>
        </div>
        <div className="w-[45%] min-w-[45%] h-full relative top-[116px] ml-8 lt:max-sm:w-[63%] lt:max-sm:top-[25px] ">
          <img
            src="/assets/images/AboutUs/medical partner.png"
            alt="Partners"
            className=""
          />
        </div>
      </section> */}
      {/* Section quatre */}
      {/* <section
        className="h-[100vh] min-h-screen bg-[url('../public/assets/images/AboutUs/formedeux.svg')] bg-no-repeat  
      bg-[position:-5%_37%] bg-[length:160%] lt:max-sm:bg-[length:230%] lt:max-sm:bg-[position:30%_30%] border border-red text-center place-content-center "
      >
        <p className="text-[#134888] font-bold text-[1.5rem] lt:max-sm:m-5 m-9">
          Solutions Proposées
        </p>
        <div
          className=" h-[70%] min-h-[20%] w-[80%] max-w-[80%] mx-auto grid gap-10 grid-cols-3 grid-rows-2 text-black border border-blue-600 font-medium
        lt:max-sm:grid-cols-2 lt:max-sm:gap-2 lt:max-sm:h-[90%] lt:max-sm:w-[100%] place-content-center "
        >
          {CardTab.map((card) => (
            <AboutCarte
              image={card.image}
              altImage={card.altImage}
              titre={card.titre}
              description={card.description}
            />
          ))}
        </div>
      </section> */}
    </main>
  );
};

export default About;
